module.exports = __webpack_public_path__ + "img/live-content.0224dd4d.png";